import { getMonth, getYear } from 'date-fns'
import { ReactDatePickerCustomHeaderProps } from 'react-datepicker'

import { FormControl } from '../../FormControl'
import { OldSelect, OldSelectOption } from '../../OldSelect'
import { getYesterdayDate } from './DayPicker'

function range(start: number, end: number) {
  return Array.from({ length: end - start + 1 }, (_, i) => i + start)
}

const years = range(2019, getYear(new Date()) + 1)

const months = [
  'January',
  'February',
  'March',
  'April',
  'May',
  'June',
  'July',
  'August',
  'September',
  'October',
  'November',
  'December',
]

export interface DayPickerHeaderProps extends ReactDatePickerCustomHeaderProps {
  showMonthAndYearSelector: boolean
  onYesterdaySelect?: (date: Date) => void
}
export function DayPickerHeader({ date, changeYear, changeMonth, onYesterdaySelect }: DayPickerHeaderProps) {
  const getYesterdayString = () => {
    const yesterday = getYesterdayDate()
    const options: Intl.DateTimeFormatOptions = { day: '2-digit', month: 'short', year: 'numeric' }
    const formatter = new Intl.DateTimeFormat('en-US', options)
    const parts = formatter.formatToParts(yesterday)
    const formattedDate = `${parts[2].value} ${parts[0].value} ${parts[4].value}`
    return formattedDate
  }

  return (
    <FormControl className='flex flex-col gap-1'>
      <div className='flex flex-col items-start gap-4'>
        <h1 className='text-base font-semibold text-gray-900'>Select a day</h1>
        <button
          className='flex h-11 w-full cursor-pointer justify-between rounded-md bg-brand-blue-500 p-3 text-white hover:bg-brand-blue-300'
          onClick={() => onYesterdaySelect && onYesterdaySelect(getYesterdayDate())}
        >
          <p className='text-sm font-semibold text-white'>Yesterday</p>
          <p className='text-sm text-blue-50'>{getYesterdayString()}</p>
        </button>
        <hr className='h-1 w-full' />
      </div>
      <div className='flex gap-1'>
        <div className='flex-1'>
          <OldSelect
            value={months[getMonth(date)]}
            displayValue={(value) => value}
            onChange={(value) => changeMonth(months.indexOf(value))}
            buttonProps={{ 'aria-label': 'Select Month From List' }}
            buttonClassName='border-0 font-semibold shadow-none !text-base'
          >
            {months.map((option) => (
              <OldSelectOption key={option} value={option} aria-label={`Choose ${option}`}>
                {option}
              </OldSelectOption>
            ))}
          </OldSelect>
        </div>
        <div className='flex-1'>
          <OldSelect
            value={getYear(date)}
            displayValue={(value) => value.toString()}
            onChange={(value) => changeYear(value)}
            buttonProps={{ 'aria-label': 'Select year from list' }}
            buttonClassName='border-0 font-semibold shadow-none !text-base'
          >
            {years.map((option) => (
              <OldSelectOption key={option} value={option} aria-label={`Choose ${option}`}>
                {option}
              </OldSelectOption>
            ))}
          </OldSelect>
        </div>
      </div>
    </FormControl>
  )
}
